<template>
    <tr :active="value.selected" @click="devePermitirSelecao ? (value.selected = !value.selected) : null" :key="value.item.idDocumentoString">
        <td>
            <v-checkbox
                v-if="devePermitirSelecao"
                :input-value="value.selected"
                color="secondary"
                hide-details
            ></v-checkbox>
            <div v-else style="width: 40px; height: 40px;"></div>
        </td>
        <td>{{ getValue(value.item.nome) }}</td>
        <td align="left">{{ getValue(value.item.descricaoTipo) }}</td>
        <td align="left">{{ getValue(value.item.fornecedorNome) }}</td>
        <td align="center">{{ getValue(value.item.quantidadeAssinaturas) }}</td>
        <td align="left">{{ getValue(value.item.situacao) }}</td>
        <td  @click.stop style="text-align: center !important;">
            <botoes-acoes :key="`botoesAcoes${value.item.idDocumentoString}`"
                          :documento="value.item"
                          @virtualizarDocumentos="$emit('virtualizarDocumentoCompraDireta', value.item)"
                          @baixarDocumentos="(tipoDownload) => $emit('baixarDocumentoCompraDireta', value.item, tipoDownload)"
                          @juntarDocumentos="$emit('juntarDocumentoCompraDireta', value.item)"
                          @desentranharDocumentos="$emit('desentranharDocumentoCompraDireta', value.item)"
                          @redigirDocumentos="$emit('redigirDocumentoCompraDireta', value.item)"
                          @reordenarDocumentos="$emit('reordenarDocumentoCompraDireta', value.item)"
                          @cancelarDocumentos="$emit('cancelarDocumentoCompraDireta', value.item)"
                          @documentoSincronizado="$emit('documentoSincronizado', $event)"
                          @acessarTermoDesentranhamento="$emit('acessarTermoDesentranhamento', value.item)"/>
        </td>
    </tr>
</template>

<script>
import BotoesAcoes from '../components/BotoesAcoes'

export default {
    name: 'DocumentoCompraDireta',
    components: {
        BotoesAcoes,
    },
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    computed: {
        devePermitirSelecao() {
            const documento = this.value.item
            if (!documento) return true
            
            const tipoDoc = (documento.tipo || '').toLowerCase()
            const descricaoTipoDoc = (documento.descricaoTipo || '').toLowerCase()
            const situacaoDoc = (documento.situacao || '').toLowerCase()
            
            const isTermoDesentranhamento = tipoDoc.includes('termo') && tipoDoc.includes('desentranhamento') ||
                                          descricaoTipoDoc.includes('termo') && descricaoTipoDoc.includes('desentranhamento')
            
            const isSituacaoGerado = situacaoDoc.includes('gerado')
            
            return !(isTermoDesentranhamento && isSituacaoGerado)
        }
    },
    methods: {
        getValue(text){
            return text || '--'
        }
    }

}
</script>

<style scoped>
#linha-tabela-documentos {
    height: 20px !important;
    max-height: 20px !important;
}

#linha-tabela-documentos * {
    height: 20px !important;
    max-height: 20px !important;
}
</style>